<template>
  <section class="py-4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">
              How to earn Reputation
            </h3>
            <h4 class="text-body-1 mb-6">
              The higher is your Reputation the more trust you will have in the
              community.<br />
              Actions performed are recorded and used to calculate your
              reputation.
            </h4>
          </div>
        </v-col>
        <v-col
          v-for="(earn, index) in earns"
          :key="index"
          cols="6"
          md="4"
          lg="3"
          xl="2"
        >
          <v-card outlined>
            <v-card-title class="text-center">
              <span class="d-block text-h6 font-weight-bold w-100-percentage">
                {{ earn.title }}
              </span>
            </v-card-title>
            <v-card-text class="text-center">
              <v-icon color="grey" large>{{ earn.icon }}</v-icon>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-0">
              <div class="d-flex justify-space-around w-100-percentage">
                <div class="text-center pa-2">
                  <span class="d-block font-weight-bold">Free</span>
                  {{ earn.free }}
                </div>
                <v-divider vertical />
                <div class="text-center pa-2">
                  <span class="d-block font-weight-bold">Pro</span>
                  {{ earn.pro }}
                </div>
                <v-divider vertical />
                <div class="text-center pa-2">
                  <span class="d-block font-weight-bold">Pro +</span>
                  {{ earn.proPlus }}
                </div>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ReputationEarn',
  data() {
    return {
      earns: [
        {
          title: 'Upload first photo',
          icon: 'fal fa-cloud-upload',
          free: '10',
          pro: '15',
          proPlus: '20'
        },
        {
          title: 'Curate a photo',
          icon: 'fal fa-gavel',
          free: '4',
          pro: '6',
          proPlus: '8'
        },
        {
          title: 'Get photo like',
          icon: 'fal fa-heart-circle',
          free: '4',
          pro: '6',
          proPlus: '8'
        },
        {
          title: 'Get album like',
          icon: 'fal fa-book-heart',
          free: '4',
          pro: '6',
          proPlus: '8'
        },
        {
          title: 'Get comment like',
          icon: 'fal fa-thumbs-up',
          free: '4',
          pro: '6',
          proPlus: '8'
        },
        {
          title: 'Inspiration published',
          icon: 'fal fa-lightbulb-on',
          free: '20',
          pro: '30',
          proPlus: '40'
        },
        {
          title: 'Elite published',
          icon: 'fal fa-star',
          free: '20',
          pro: '30',
          proPlus: '40'
        },
        {
          title: 'Prime published',
          icon: 'fas fa-image',
          free: '20',
          pro: '30',
          proPlus: '40'
        },
        {
          title: 'Upcoming published',
          icon: 'far fa-image',
          free: '10',
          pro: '15',
          proPlus: '20'
        },
        {
          title: 'Upload avatar',
          icon: 'fal fa-user-circle',
          free: '10',
          pro: '15',
          proPlus: '20'
        },
        {
          title: 'Complete profile',
          icon: 'fal fa-user-astronaut',
          free: '20',
          pro: '30',
          proPlus: '40'
        },
        {
          title: '100 Followers',
          icon: 'fal fa-users',
          free: '50',
          pro: '75',
          proPlus: '100'
        },
        {
          title: 'Reply to a comment',
          icon: 'fal fa-comment-lines',
          free: '4',
          pro: '6',
          proPlus: '8'
        }
      ]
    }
  }
}
</script>
